// import { setPropertySchema } from "../utils/helpers";

export class Elements {
  form;
  name;
  blocklist;

  constructor(form, name, blocklist) {
    this.form = form;
    this.name = name;
    this.blocklist = blocklist;
  }

  /**
   * Checks if a given HTML element matches any selector in the FullStory privacy blocklist.
   * @param el - The HTMLElement to check.
   * @returns true if the element matches any selector in the blocklist, false otherwise.
   */
  isBlocked(el) {
    if (!el || !this.blocklist || this.blocklist.length === 0) return false;

    for (const selector of this.blocklist) {
      try {
        if (el.matches('.fs-unmask')) {
          return false;
        }
        if (el.matches(selector)) {
          return true;
        }
      } catch (err) {
        console.warn(`Invalid selector in blockList: ${selector}`, err);
      }
    }

    return false;
  }

  getName = (el) => {
    const directName = el.getAttribute('name');
    if (directName) return directName;

    const ariaLabel = el.getAttribute('aria-label');
    if (ariaLabel) return ariaLabel;

    const ariaLabelledBy = el.getAttribute('aria-labelledby');
    if (ariaLabelledBy) {
      const labelEl = document.getElementById(ariaLabelledBy);
      if (labelEl && labelEl.textContent) return labelEl.textContent;
    }

    const placeholder = el.getAttribute('placeholder');
    if (placeholder) return placeholder;

    const id = el.id;
    if (id) {
      const externalLabel = document.querySelector(`label[for="${id}"]`);
      if (externalLabel && externalLabel.textContent) return externalLabel.textContent;
    }

    // check for wrapping <label><input ... /></label>
    const wrappingLabel = el.closest('label');
    if (wrappingLabel && wrappingLabel.textContent) return wrappingLabel.textContent;

    const classList = el.className?.trim();
    if (classList) return classList;

    return 'unknown-input';
  };
}
